import { unescape } from 'lodash';

const STRIP_TAGS_REG = /(<([^>]+)>)/gi;
const HTML_BLOCK_SEPARATOR_REG = /<\/?(?:br|div|li|p)[^>]*>/gi;

export function stripTags(str) {
  return str.replace(STRIP_TAGS_REG, '');
}

export function htmlToPlainText(str) {
  if (typeof str !== 'string') return '';

  return stripTags(unescape(str).replace(HTML_BLOCK_SEPARATOR_REG, ' '))
    .replace(/\s+/g, ' ')
    .trim();
}

export function escape(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
